import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';

export const useBatteryState = (): RootState['battery'] => {
  const state = useSelector<RootState, RootState['battery']>(
    (state) => state.battery,
  );

  useDebugValue(state);

  return state;
};
